/**
 * ExpertRoutingPage - Expert routing and capacity management dashboard
 *
 * Surfaces the ExpertRoutingDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides intelligent work assignment, capacity visualization, and routing decision audit.
 *
 * Route: /admin/expert-routing
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconRoute } from '@tabler/icons-react';

import { ExpertRoutingDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ExpertRoutingPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconRoute size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Expert Routing</Title>
            <Text size="sm" c="dimmed">
              Intelligent work assignment, capacity management, and routing decisions
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ExpertRoutingDashboard />
    </Container>
  );
}

export default ExpertRoutingPage;
